import React from "react";
import { motion } from "framer-motion";
import TypewriterComponent from "typewriter-effect";
import "../Portfolio.css";

const AboutMe = () => {
  return (
    <div className="about-section">
      <motion.h1
        className="about-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        About<span className="about-dot">.</span>
      </motion.h1>
      <motion.div
        className="about-wrapper"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
      >
        <div className="about-bg-card">
          <h2 className="about-card-title">Who am I?</h2>
          <p className="about-card-text">
            I am a self-taught software developer located in South Bend, IN. I
            have a passion for designing UI effects, animations, and crafting
            user experiences that are dynamic, intuitive, and engaging. Aside
            from programming, I like outdoor activities and anything else
            related to tech. I am a quick learner and strive to know as much as
            I can about anything I feel passionate about.
          </p>
        </div>
        <div className="about-floating-card">
          <h2 className="about-card-title">What I Do</h2>
          <h3 className="about-role">Software Developer</h3>
          <div className="about-typewriter">
            <h4>Interests:</h4>
            <TypewriterComponent
              options={{
                strings: [
                  "Web & App Development",
                  "UI Design",
                  "Mountain Biking",
                  "Mechanics",
                  "Volleyball",
                  "Video Games",
                ],
                autoStart: true,
                loop: true,
              }}
            />
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AboutMe;
